module.exports = __webpack_public_path__ + "img/kamalesh.98f06c32.jpeg";